module.exports = __webpack_public_path__ + "img/fb.87d02221.png";